class PostingPlatformsUtility

  @DEFAULTS:
    Signage:
      name: 'Signage'
      iconClass: 'far fa-sign'
      bgColor: '#15B9D6'
      special: true
    Email:
      name: 'Email'
      iconClass: 'far fa-envelope'
      bgColor: '#15B9D6'
      special: false
    Facebook:
      name: 'Facebook'
      iconClass: 'fab fa-facebook'
      bgColor: '#4267B2'
      special: false
    Instagram:
      name: 'Instagram'
      iconClass: 'fab fa-instagram'
      bgColor: '#AA1AEE'
      special: false
    TikTok:
      name: 'TikTok'
      iconClass: 'fab fa-tiktok'
      bgColor: '#000000'
      special: false
    YouTube:
      name: 'YouTube'
      iconClass: 'fab fa-youtube'
      bgColor: '#FF0000'
      special: false
    Twitter:
      name: 'Twitter'
      iconClass: 'fab fa-twitter'
      bgColor: '#199CEA'
      special: false

  @getPlatformsDefaults: ->
    JSON.parse(JSON.stringify(@DEFAULTS))

  @iconForPlatform: (name) ->
    @DEFAULTS[name]?.iconClass || "far fa-at" # "far fa-#{name.charAt(0).toLowerCase()}"

  @bgForPlatform: (name) ->
    @DEFAULTS[name]?.bgColor || '#15B9D6'

export default PostingPlatformsUtility
